(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!window.vivacFeaturedCollectionProgressReady) {
    window.vivacFeaturedCollectionProgressReady = true;

    const updateVivacProductProgress = (counter) => {
      const current = Number.parseInt(counter.querySelector('.slider-counter--current')?.textContent, 10);
      const total = Number.parseInt(counter.querySelector('.slider-counter--total')?.textContent, 10);

      if (!Number.isFinite(current) || !Number.isFinite(total) || total < 1) return;

      counter.style.setProperty('--vivac-product-slider-progress', Math.min(current / total, 1));
      counter.setAttribute('aria-label', `${current} de ${total}`);
    };

    const syncVivacProductProgress = (root = document) => {
      root.querySelectorAll('.featured-collection-carousel .slider-counter').forEach(updateVivacProductProgress);
    };

    const vivacProductProgressObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const counter = mutation.target.closest?.('.featured-collection-carousel .slider-counter');
        if (counter) updateVivacProductProgress(counter);
      });
    });

    const initializeVivacProductProgress = () => {
      syncVivacProductProgress();
      vivacProductProgressObserver.observe(document.body, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeVivacProductProgress, { once: true });
    } else {
      initializeVivacProductProgress();
    }

    document.addEventListener('shopify:section:load', (event) => {
      syncVivacProductProgress(event.target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivac-accessories-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.vivacAccessoriesShowcaseReady) {
    window.vivacAccessoriesShowcaseReady = true;

    const updateVivacAccessoriesProgress = (section) => {
      const carousel = section.querySelector('[data-vivac-accessories-carousel]');
      const progress = section.querySelector('[data-vivac-accessories-progress]');
      if (!carousel || !progress) return;

      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const scrollRatio = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 1;
      const progressRatio = 0.2 + scrollRatio * 0.8;
      progress.style.transform = `scaleX(${Math.min(Math.max(progressRatio, 0), 1)})`;
    };

    const syncVivacAccessoriesProgress = (root = document) => {
      root.querySelectorAll('[data-vivac-accessories]').forEach(updateVivacAccessoriesProgress);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-vivac-accessories-previous], [data-vivac-accessories-next]'
      );
      if (!button) return;

      const section = button.closest('[data-vivac-accessories]');
      const carousel = section?.querySelector('[data-vivac-accessories-carousel]');
      const firstCard = carousel?.querySelector('.vivac-accessories__card');
      if (!section || !carousel || !firstCard) return;

      const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
      const direction = button.hasAttribute('data-vivac-accessories-next') ? 1 : -1;
      carousel.scrollBy({
        left: direction * (firstCard.getBoundingClientRect().width + gap),
        behavior: 'smooth'
      });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const carousel = event.target.closest?.('[data-vivac-accessories-carousel]');
        if (!carousel) return;
        const section = carousel.closest('[data-vivac-accessories]');
        if (section) updateVivacAccessoriesProgress(section);
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncVivacAccessoriesProgress(), {
        once: true
      });
    } else {
      syncVivacAccessoriesProgress();
    }

    document.addEventListener('shopify:section:load', (event) => {
      syncVivacAccessoriesProgress(event.target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivac-pecron-families"] && !Shopify.designMode) return;
  try {
    
  if (!window.vivacPecronFamiliesReady) {
    window.vivacPecronFamiliesReady = true;

    const updateVivacPecronProgress = (section) => {
      const carousel = section.querySelector('[data-vivac-pecron-carousel]');
      const progress = section.querySelector('[data-vivac-pecron-progress]');
      if (!carousel || !progress) return;

      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const ratio = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 1;
      progress.style.transform = `scaleX(${0.34 + ratio * 0.66})`;
    };

    document.addEventListener(
      'scroll',
      (event) => {
        const carousel = event.target.closest?.('[data-vivac-pecron-carousel]');
        if (!carousel) return;
        const section = carousel.closest('[data-vivac-pecron-families]');
        if (section) updateVivacPecronProgress(section);
      },
      true
    );

    const syncVivacPecronProgress = (root = document) => {
      root.querySelectorAll('[data-vivac-pecron-families]').forEach(updateVivacPecronProgress);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncVivacPecronProgress(), { once: true });
    } else {
      syncVivacPecronProgress();
    }

    document.addEventListener('shopify:section:load', (event) => {
      syncVivacPecronProgress(event.target);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
